export const ExperimentId = {
  SEARCH_PAGE_TILE: 'searchPageTile',
  SEARCH_FORM_DATE: 'searchFormDate',
  TOTAL_PRICE: 'totalPrice',
  SECTION_HERO: 'sectionHero'
};

export const ExperimentVariant = {
  CONTROL: 'control',
  VARIANT_A: 'variant_a',
  VARIANT_B: 'variant_b',
};

const isPoland = process.env.REACT_APP_COUNTRY_ID === 'pl';

export const ExperimentsWithVariants = {
  // [ExperimentId.SEARCH_FORM_DATE]: {
  //   defaultVariant: ExperimentVariant.CONTROL,
  //   variants: [ExperimentVariant.CONTROL, ExperimentVariant.VARIANT_A],
  //   weights: [40, 60],
  //   allowedCountries: ['pl'],
  // },
  [ExperimentId.TOTAL_PRICE]: {
    defaultVariant: ExperimentVariant.CONTROL,
    variants: [ExperimentVariant.CONTROL, ExperimentVariant.VARIANT_A, ExperimentVariant.VARIANT_B],
    weights: isPoland ? [33, 33, 34] : [100, 0, 0],
    // allowedCountries: ['pl'],
  },
  [ExperimentId.SECTION_HERO]: {
    defaultVariant: ExperimentVariant.CONTROL,
    variants: [ExperimentVariant.CONTROL, ExperimentVariant.VARIANT_A],
    weights: isPoland ? [50, 50] : [100, 0],
    allowedCountries: ['pl'],
  },
};

export { initMissingAbExperiments } from './utils';
